module.exports = __webpack_public_path__ + "img/action-cam-3.51c58982.png";